<form [formGroup]="form">
  <app-form-control label="Właściciel">
    <p-select
      [formControl]="form.controls.ownerId"
      [options]="valueOrDefault(ownerSelectItems$ | async, [])"
      appPrimengSelect
      [fluid]="true"
      placeholder="Wybierz właściciela" />
  </app-form-control>

  <app-form-control label="Lokalizacja">
    <p-select
      [filter]="true"
      [formControl]="form.controls.localizationId"
      [options]="valueOrDefault(localizationSelectItems$ | async, [])"
      appPrimengSelect
      [fluid]="true"
      placeholder="Wybierz lokalizację" />
  </app-form-control>

  <app-form-control label="Nazwa">
    <input
      [formControl]="form.controls.name"
      pInputText
      placeholder="Wprowadź nazwę" />
  </app-form-control>

  <app-form-control label="Marka kosmetyczna">
    <p-select
      [filter]="true"
      [formControl]="form.controls.brandId"
      [options]="valueOrDefault(brandSelectItems$ | async, [])"
      appPrimengSelect
      [fluid]="true"
      placeholder="Wybierz markę kosmetyczną" />
  </app-form-control>

  <app-form-control
    inputId="c4a0c8e3-878b-458d-9a4e-5f2ebebb8de3"
    label="Promocja">
    <app-checkbox-with-label
      inputId="c4a0c8e3-878b-458d-9a4e-5f2ebebb8de3"
      type="short">
      <p-checkbox
        [binary]="true"
        [formControl]="form.controls.promotion" />

      <span label>Produkt promocyjny</span>
    </app-checkbox-with-label>
  </app-form-control>

  <app-form-control
    hint="Zmiana rodzaju dostępna tylko dla obiektu będącego szkicem. Przy zmianie powiązany obiekt zostanie usunięty, a dla nowego rodzaju utworzony zostanie nowy obiekt."
    label="Rodzaj">
    <p-select
      [formControl]="form.controls.type"
      [options]="valueOrDefault(productTypeSelectItems$ | async, [])"
      appPrimengSelect
      [fluid]="true"
      placeholder="Wybierz rodzaj" />
  </app-form-control>

  <app-form-control label="Numer artykułu (SKU)">
    <input
      [formControl]="form.controls.sku"
      pInputText
      placeholder="Wprowadź numer artykułu" />
  </app-form-control>

  <div class="grid grid-cols-2 gap-4">
    <app-form-control label="Ilość">
      <input
        [formControl]="form.controls.quantity"
        pInputText
        placeholder="Wprowadź ilość"
        type="number" />
    </app-form-control>

    @if (unitSelectItems$ | async; as options) {
      <app-form-control label="Jednostka miary">
        <p-select
          [formControl]="form.controls.unit"
          [options]="valueOrDefault(unitSelectItems$ | async, [])"
          placeholder="Wybierz jednostkę miary"
          appPrimengSelect
          [fluid]="true" />
      </app-form-control>
    }
  </div>

  <div class="grid grid-cols-2 gap-4">
    <app-form-control
      hint="Przykład: 30 dni od otwarcia, 60 dni od daty produkcji."
      label="Okres przydatności">
      <input
        [formControl]="form.controls.durabilityInformation"
        pInputText
        placeholder="Wprowadź okres przydatności" />
    </app-form-control>

    <app-form-control
      hint="Przykład: 2x15ml."
      label="Miara towaru">
      <input
        [formControl]="form.controls.measure"
        pInputText
        placeholder="Wprowadź miarę towaru" />
    </app-form-control>
  </div>

  <div class="flex justify-end">
    <p-button
      (onClick)="handleSubmitClick()"
      [disabled]="form.invalid"
      appPrimengButton
      label="Zapisz"
      severity="primary"
      type="submit" />
  </div>
</form>
